// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@electrowire/XDL/types";
import { css } from "styled-components";

export default {
    css: css`
        body {
            &:after {
                transition: background-color 600ms ease;
                content: "";
                position: fixed;
                top: 0;
                left: 0;
                z-index: 9;
                width: 100%;
                height: 100%;
                pointer-events: none;
            }
        }
        body.shade {
            &:after {
                background-color: rgba(0, 0, 0, 0.75);
            }
        }

        *:focus {
            outline: none !important;
        }

        @media print {
            #chatButton {
                display: none;
            }
        }
    `,
} as xBaseTheme["globalStyle"];
